var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBubbleEllipsisStroke = function SvgIconBubbleEllipsisStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    d: "M19.25 2A3.76 3.76 0 0 1 23 5.75v8.5A3.76 3.76 0 0 1 19.25 18h-5.191L9 24H8v-6H4.75A3.76 3.76 0 0 1 1 14.25v-8.5A3.76 3.76 0 0 1 4.75 2zM3.7 3.7c-.55 0-1 .45-1 1v10.6c0 .55.45 1 1 1h6v4.223l3.562-4.223H20.3c.55 0 1-.45 1-1V4.7c0-.55-.45-1-1-1zM8 9a1 1 0 1 1 0 2 1 1 0 1 1 0-2m4 0a1 1 0 1 1 0 2 1 1 0 1 1 0-2m4 0a1 1 0 1 1 0 2 1 1 0 1 1 0-2"
  })));
};
export default SvgIconBubbleEllipsisStroke;